export default __webpack_public_path__ + "static/transferLogo-6c6cf601ba0e31b97ad4af8086e90ac8.svg";